import { render, staticRenderFns } from "./_sharing_modal.vue?vue&type=template&id=40bce590&"
import script from "./_sharing_modal.vue?vue&type=script&lang=js&"
export * from "./_sharing_modal.vue?vue&type=script&lang=js&"
import style0 from "./_sharing_modal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports